import { skipToken } from "@reduxjs/toolkit/query";

import { useAppSelector } from "~/app/store";
import { useGetMultiTempGridInfo } from "~/hooks/useGetMultiTempGridInfo";
import { selectThisWorkstation } from "~/redux/selectors/workstationsSelectors";
import { useGetWorkstationPickingConfigurationQuery } from "~/redux/warehouse/workstation.hooks";

export function useWorkstationPickingConfiguration() {
  const { isMultiTempGrid } = useGetMultiTempGridInfo();
  const siteWorkstation = useAppSelector(selectThisWorkstation);
  const isEnabled =
    !!siteWorkstation?.autostoreGridId &&
    !!siteWorkstation?.id &&
    isMultiTempGrid;
  const { data, isFetching, isError, isSuccess, refetch } =
    useGetWorkstationPickingConfigurationQuery(
      isEnabled
        ? {
            autostoreGridId: siteWorkstation.autostoreGridId,
            workstationId: siteWorkstation.id
          }
        : skipToken,
      { refetchOnMountOrArgChange: true }
    );
  const configuration = data?.configuration;
  const isConfigurationReady = isEnabled && isSuccess && !isFetching;

  return {
    isEnabled,
    configuration,
    isError,
    isConfigurationReady,
    refetch,
    isStartPickingBlocked: isEnabled && !isConfigurationReady
  };
}
